export default "__VITE_ASSET__d1192c59__"